"function"!=typeof Object.entries&&(Object.entries=function(e){for(var t=Object.keys(e),n=t.length,r=new Array(n);n--;)r[n]=[t[n],e[t[n]]];return r});



//////////////////
// WEBPACK FOOTER
// ./node_modules/mdn-polyfills/Object.entries.js
// module id = 1282
// module chunks = 0